import React from 'react';

export function ConstantField({ additionalReportingColumn }) {
  const { value } = additionalReportingColumn;
  return <p>{value}</p>;
}
